import CheckmateApiClient from '../../../services/apiClient';
import { HttpResponseError } from '../../../interfaces/IHttpResponseError';
import { ISameCaseEasyUpdateModel } from './ISameCaseEasyUpdateModel';
import { useMutation } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useSaveSameCaseEasyUpdateMutation = () => {
    return useMutation({
        mutationFn: async (caseModel: ISameCaseEasyUpdateModel | undefined) => {
            if (!caseModel) throw new Error('Failed to update same case easy update');

            const response = await _apiClient.saveSameCaseEasyUpdate(
                caseModel.sameCaseGuid,
                caseModel
            );

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error(
                    'Failed to update same case easy update'
                );
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
    });
};
